import React, { Fragment } from 'react'

import { useLocation } from 'react-router-dom'
import { useTourGuide } from 'context/tour-guide/use-tour-guide'
import { useWindowSize } from 'hooks'
import {
  StyledArrow,
  StyledText,
  SwitchContentContainer,
  SwitchElements,
  SwitchItem,
  SwitcherContainer,
} from './styled'
import { SwitchElement } from './interface'
import { ProductDetailsTabSwitcher } from './tab-switch'
import { ProductPageComponentProps } from '../../interfaces'
import { ProductPreviewSwitchMenu } from '../../storage/interface'

export const ContentSwitch: React.FC<ProductPageComponentProps> = ({ store, productMetadata }) => {
  const { product, dispatch, productPreviewSelection } = store

  const allocation = product.assets
  const { pathname } = useLocation()
  const { performanceSectionOpen, run, currentStep } = useTourGuide()
  const runningOrPaused = run || currentStep > 0
  const { isMobile } = useWindowSize()

  /**
   * Filters to determine what tabs to show
   * @param item
   * @returns
   */
  const shouldShowPerformance = (item: SwitchElement) => {
    if (item === SwitchElement.PERFORMANCE) {
      return performance !== null
    } else {
      return item
    }
  }

  const byProductType = (item: SwitchElement) => item

  const shouldShowAllocation = (item: SwitchElement) => {
    if (item === SwitchElement.ASSET_ALLOCATION) {
      return allocation && allocation.length !== 0
    } else {
      return item
    }
  }

  const shouldShowAdditionalInfo = (item: SwitchElement) => {
    if (item === SwitchElement.ADDITIONAL_INFO) {
      return !!product.created
    } else {
      return item
    }
  }

  const currentSwitchMenu = ProductPreviewSwitchMenu.filter(byProductType)
    .filter(shouldShowAllocation)
    .filter(shouldShowAdditionalInfo)
    .filter(shouldShowPerformance)

  React.useEffect(() => {
    dispatch({ type: 'set_selected_product_preview', payload: SwitchElement.PERFORMANCE })
  }, [pathname])

  React.useEffect(() => {
    if (runningOrPaused) {
      dispatch({ type: 'set_selected_product_preview', payload: SwitchElement.PERFORMANCE })
    }
  }, [performanceSectionOpen, run, currentStep])
  return (
    <SwitchContentContainer>
      {isMobile && (
        <SwitcherContainer>
          <SwitchElements id="tour-performance">
            {currentSwitchMenu.map((el) => (
              <Fragment key={`${el}`}>
                <SwitchItem
                  id={`tour-performance-${el}`}
                  onClick={() => dispatch({ type: 'set_selected_product_preview', payload: el })}
                >
                  <StyledText active={el === productPreviewSelection}>{el}</StyledText>
                  <StyledArrow
                    size={10}
                    direction={productPreviewSelection === el ? 'top' : 'bottom'}
                  />
                </SwitchItem>
                {el === productPreviewSelection && (
                  <ProductDetailsTabSwitcher
                    element={productPreviewSelection}
                    store={store}
                    productMetadata={productMetadata}
                  />
                )}
              </Fragment>
            ))}
          </SwitchElements>
        </SwitcherContainer>
      )}
      {!isMobile && (
        <SwitcherContainer>
          <SwitchElements id="tour-performance">
            {currentSwitchMenu.map((el) => (
              <SwitchItem
                onClick={() => dispatch({ type: 'set_selected_product_preview', payload: el })}
                key={`${el}`}
              >
                <StyledText active={el === productPreviewSelection}>{el}</StyledText>
              </SwitchItem>
            ))}
          </SwitchElements>
        </SwitcherContainer>
      )}
      {!isMobile && (
        <ProductDetailsTabSwitcher
          element={productPreviewSelection}
          store={store}
          productMetadata={productMetadata}
        />
      )}
    </SwitchContentContainer>
  )
}
